import { useAuth } from "@certa/auth/AuthenticationProvider";

const USER_KINDS = {
  CLIENT: 1,
  THIRD_PARTY: 2
} as const;

export const useIsClientUserKind = () => {
  const { user } = useAuth();
  const isClientUserKind = user?.kind === USER_KINDS.CLIENT;
  return isClientUserKind;
};
